import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GenericErrorProps } from 'store/store.types';

export interface ErrorState {
    genericError: GenericErrorProps;
}

const initialState: ErrorState = {
    genericError: {
        show: false,
    },
};

const error = createSlice({
    name: 'error',
    initialState,
    reducers: {
        showGenericError: (state, action: PayloadAction<{ message: string }>) => {
            state.genericError.show = true;
            state.genericError.message = action.payload.message;
        },
        hideGenericError: (state) => {
            state.genericError.show = false;
            state.genericError.message = '';
        },
    },
});

export const { showGenericError, hideGenericError } = error.actions;
export default error.reducer;
